import { PaymentType } from '../../../types/common';
import { PaymentService } from '../../../types/paymentService';
import { STORE_PROPS } from '../../constants';
import { usePaymentsStore } from '../../store';

const { ACTIVE_SERVICE_ID, ACTIVE_PAYMENT_TYPE, PAYMENT_SERVICES } =
  STORE_PROPS;

export const useGetPaymentService = (): PaymentService => {
  const { activeServiceId, activePaymentType, paymentServices } =
    usePaymentsStore([
      ACTIVE_SERVICE_ID,
      ACTIVE_PAYMENT_TYPE,
      PAYMENT_SERVICES
    ]);

  return (
    paymentServices?.[activePaymentType as PaymentType]?.data?.[
      activeServiceId as number
    ] || {}
  );
};
